<ng-container *ngIf="!userSignedIn">
  <a *ngIf="!requiresSignIn || type === 'subject'"
    class="button hollow browse no-underline"
    [ngClass]="(type) ? 'browse--' + type : ''"
    [routerLink]="[slug]"
    data-test="lmw-common-subject-topic-link-button"
  >
    <span>{{text}}</span>
    <svg
      *ngIf="!completed"
      class="icon icon--chevron-right icon--material"
      [ngClass]="'icon--' + iconColour"
      viewBox="0 0 36 36"
    ><use xlink:href="#icon-chevron-right" href="#icon-chevron-right"></use></svg>
    <svg *ngIf="completed" class="icon icon--checkmark icon--success" viewBox="0 0 36 36">
      <use xlink:href="#icon-checkmark" href="#icon-checkmark"></use>
    </svg>
  </a>
  <span *ngIf="requiresSignIn && type !== 'subject'"
    class="button hollow browse browse--topic browse--topic-locked no-underline"
    data-test="lmw-common-subject-topic-link-button-locked"
  >
    <span>{{text}}</span>
    <svg aria-label="a lock symbol"
      class="icon icon--lock"
      viewBox="0 0 36 36"
    ><use xlink:href="#icon-lock" href="#icon-lock"></use></svg>
  </span>
</ng-container>

<a *ngIf="userSignedIn"
  class="button hollow browse no-underline"
  [ngClass]="(type) ? 'browse--' + type : ''"
  [routerLink]="[slug]"
  data-test="lmw-common-subject-topic-link-button"
>
  <span>{{text}}</span>
  <svg
    *ngIf="!completed"
    class="icon icon--chevron-right icon--material"
    [ngClass]="'icon--' + iconColour"
    viewBox="0 0 36 36"
  ><use xlink:href="#icon-chevron-right" href="#icon-chevron-right"></use></svg>
  <svg *ngIf="completed" class="icon icon--checkmark icon--success" viewBox="0 0 36 36">
    <use xlink:href="#icon-checkmark" href="#icon-checkmark"></use>
  </svg>
</a>
